import React from "react";
import { useSelector } from "react-redux";
import ExpenseRequests from "../../components/expense-management/ExpenseRequests";
import { selectUser } from "../../components/auth/auth.selector";

const ExpenseManagement = () => {
  const userInfoData = useSelector(selectUser);

  return <ExpenseRequests userInfoData={userInfoData} />;
};

export default ExpenseManagement;
